<div
  class="wm-overlay-backdrop"
  *ngIf="isOpen"
  (click)="handleBackdropClick()"
>
  <div
    class="wm-overlay-content"
    [style.margin-top.px]="offsetTop"
    [style.max-width]="maxWidth"
    [style.height]="height"
    [style.min-height]="minHeight"
    (click)="$event.stopPropagation()"
  >
    <div class="wm-overlay-header">
      <span class="header-title">{{ headerTitle }}</span>
      <!-- Added by Amisha on 04/24/2026: keep the shared overlay close action from submitting parent forms such as Settings Departments edit. -->
      <button type="button" class="header-close-btn" (click)="closeModal()" aria-label="Close modal">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <div class="wm-overlay-body" [ngStyle]="{ padding: bodyPadding }">
      <ng-content></ng-content>
    </div>

    <div class="wm-overlay-footer">
      <ng-content select="[modal-footer]"></ng-content>
    </div>
  </div>
</div>